import { render, staticRenderFns } from "./ClientIndex.vue?vue&type=template&id=e9befa92"
import script from "./ClientIndex.vue?vue&type=script&lang=js"
export * from "./ClientIndex.vue?vue&type=script&lang=js"
import style0 from "./ClientIndex.vue?vue&type=style&index=0&id=e9befa92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports